import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import { ErrorBoundary } from './components/common/ErrorBoundary'
import './index.css'

// ---------------------------------------------------------------------------
// Global error guardrails
// ---------------------------------------------------------------------------
// 1. Catch unhandled promise rejections so a single background failure doesn't
//    spam the console. The ErrorBoundary handles render errors; this handles
//    async ones that don't go through React (e.g. Supabase background refresh,
//    browser-extension chatter).
// 2. We swallow the well-known "message channel closed" noise that browser
//    extensions emit — it's never our code, and it confuses users.
const EXTENSION_NOISE = [
  'message channel closed',
  'Extension context invalidated',
  'A listener indicated an asynchronous response',
]
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || event.reason || '')
  if (EXTENSION_NOISE.some((p) => msg.includes(p))) {
    event.preventDefault()
    return
  }
  // eslint-disable-next-line no-console
  console.warn('[Radiance] Unhandled rejection:', event.reason)
})
window.addEventListener('error', (event) => {
  const msg = String(event.message || '')
  if (EXTENSION_NOISE.some((p) => msg.includes(p))) {
    event.preventDefault()
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: {
              background: '#0F4942',
              color: '#FDFCF8',
              borderRadius: '14px',
              padding: '12px 16px',
              fontSize: '14px',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 500,
              boxShadow: '0 10px 30px -10px rgba(15,73,66,0.4)',
            },
            success: { iconTheme: { primary: '#34CAB6', secondary: '#0F4942' } },
            error: { iconTheme: { primary: '#FF8A8A', secondary: '#0F4942' } },
          }}
        />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
